<div class="error flex flex--box flex__justify-content--center flex__align-items--center">
  <mat-card class="error--content">
    <h3 class="text--center">{{error.error}} - {{error.statusCode}}</h3>
    <h4 class="text--center">{{error.message}}</h4>
  </mat-card>
</div>
